import { BrowserRouter as Router } from 'react-router-dom';
import { AuthContextProvider } from './services/AuthContext';
import RoutesComp from './router/RoutesComp';
import useExpirationDate from 'hooks/useExpirationDate';
import ExpirationComp from 'components/Expiration';

const App = () => {
	const { expired, isLoading } = useExpirationDate();

	if (!expired && isLoading) {
		return <p>Verificando acceso...</p>;
	}

	if (expired) {
		return <ExpirationComp />
	}

	return (
		<Router>
			<AuthContextProvider>
				<RoutesComp />
			</AuthContextProvider>
		</Router>
	);
}

export default App;